export enum PositionsTabId {
  TABLE = 0,
  MAP = 1,
}
